import { RootState } from '@algoan/dashboard/store/store';
import { NotificationContent, NotificationStatus, NotificationInfo } from '@algoan/dashboard/model';
import { createSelector } from '@reduxjs/toolkit';

export const notificationSelector = (state: RootState): NotificationContent | undefined =>
  state.appState.notifications[0]?.notification;

export const notificationStatusSelector: (state: RootState) => NotificationStatus = createSelector(
  (state: RootState): NotificationInfo[] => state.appState.notifications,
  (notifications: NotificationInfo[]): NotificationStatus => {
    if (notifications.length === 0) {
      return NotificationStatus.IDLE;
    }
    return notifications[0].notificationStatus;
  },
);

export const showOnboardingSelector = (state: RootState): boolean => state.appState.showOnboarding;
export const multiAccountSelector = (state: RootState): boolean => state.appState.errorMultiAccount;
